import { updatePersonalDataPathFromCheckout } from 'app/services/businessFunctions/helpers/updatePersonalDataPathFromCheckout';

const onCheckoutOwnerNameChange = {
  onCheckoutOwnerNameChange() {
    updatePersonalDataPathFromCheckout();
  },
};

export default onCheckoutOwnerNameChange;
